export var ENotificationType;
(function (ENotificationType) {
    ENotificationType["NORMAL"] = "NORMAL";
    ENotificationType["SUCCESS"] = "SUCCESS";
    ENotificationType["WARNING"] = "WARNING";
    ENotificationType["INFO"] = "INFO";
    ENotificationType["ERROR"] = "ERROR";
})(ENotificationType || (ENotificationType = {}));
